import React from "react";

import { getDrawingBlob, listMyDrawings } from "../myDrawings";

// Local "Mine" data hook. Reads the localStorage index, bulk-loads
// blobs from IDB, applies the filter, returns SubmissionTile-shaped
// items so the caller can render them through the same pipeline as
// public submissions.
//
// Refreshes when the window regains focus to catch changes from
// other tabs (or from the main app between gallery visits in the
// same tab).
export default function useMyDrawings(filter = "all") {
  const [entries, setEntries] = React.useState(() => listMyDrawings());
  const [blobs, setBlobs] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);
    Promise.all(
      entries.map(async (e) => [e.id, await getDrawingBlob(e.id)]),
    ).then((pairs) => {
      if (cancelled) return;
      const map = {};
      for (const [id, blob] of pairs) if (blob) map[id] = blob;
      setBlobs(map);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [entries]);

  React.useEffect(() => {
    const refresh = () => setEntries(listMyDrawings());
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, []);

  const items = React.useMemo(
    () =>
      entries
        .filter((e) => blobs[e.id])
        .filter((e) => (filter === "syndicated" ? !!e.submission : true))
        .map((e) => ({
          id: e.id,
          marcId: e.marcId,
          eggId: e.eggId,
          strokesBlob: blobs[e.id],
          source: e.source,
          submission: e.submission,
          createdAt: e.createdAt,
        })),
    [entries, blobs, filter],
  );

  return { items, loading };
}
